import {
  Ref, ref, watchEffect,
} from 'vue';
import { ModuleBRModule, IBRModuleState } from '@/store/modules/br.store';

type UseAccount = {
  extensionAddress: Ref<IBRModuleState['extensionAddress']>;
  burnRedeemIndex: Ref<IBRModuleState['burnRedeemIndex']>;
  redeemContractAddress: Ref<IBRModuleState['redeemContractAddress']>;
  burn: Ref<IBRModuleState['burn']>;
  redeemSpec: Ref<IBRModuleState['redeemSpec']>;
  burnSpecs: Ref<IBRModuleState['burnSpecs']>;
  extensionContract: Ref<IBRModuleState['extensionContract']>;
  extensionVersion: Ref<IBRModuleState['extensionVersion']>;
  extensionFees: Ref<IBRModuleState['extensionFees']>;
  redeemContract: Ref<IBRModuleState['redeemContract']>;
  studioInstance: Ref<IBRModuleState['studioInstance']>;
  redeemAssetMetadata: Ref<IBRModuleState['redeemAssetMetadata']>;
  status: Ref<"not-started" | "enabled" | "ended" | null>;
  contractsToApprove: Ref<string[]>;
};

export function useBR(): UseAccount {
  const extensionAddress = ref<IBRModuleState['extensionAddress']>(ModuleBRModule.extensionAddress);
  const burnRedeemIndex = ref<IBRModuleState['burnRedeemIndex']>(ModuleBRModule.burnRedeemIndex);
  const redeemContractAddress = ref<IBRModuleState['redeemContractAddress']>(ModuleBRModule.redeemContractAddress);
  const burn = ref<IBRModuleState['burn']>(ModuleBRModule.burn);
  const redeemSpec = ref<IBRModuleState['redeemSpec']>(ModuleBRModule.redeemSpec);
  const burnSpecs = ref<IBRModuleState['burnSpecs']>(ModuleBRModule.burnSpecs);
  const extensionContract = ref<IBRModuleState['extensionContract']>(ModuleBRModule.extensionContract);
  const extensionVersion = ref<IBRModuleState['extensionVersion']>(ModuleBRModule.extensionVersion);
  const extensionFees = ref<IBRModuleState['extensionFees']>(ModuleBRModule.extensionFees);
  const redeemContract = ref<IBRModuleState['redeemContract']>(ModuleBRModule.redeemContract);
  const studioInstance = ref<IBRModuleState['studioInstance']>(ModuleBRModule.studioInstance);
  const redeemAssetMetadata = ref<IBRModuleState['redeemAssetMetadata']>(ModuleBRModule.redeemAssetMetadata);
  const status = ref<"not-started" | "enabled" | "ended" | null>(null);
  const contractsToApprove = ref<string[]>([]);

  watchEffect(() => {
    extensionAddress.value = ModuleBRModule.extensionAddress;
    burnRedeemIndex.value = ModuleBRModule.burnRedeemIndex;
    redeemContractAddress.value = ModuleBRModule.redeemContractAddress;
    burn.value = ModuleBRModule.burn;
    redeemSpec.value = ModuleBRModule.redeemSpec;
    burnSpecs.value = ModuleBRModule.burnSpecs;
    extensionContract.value = ModuleBRModule.extensionContract;
    extensionVersion.value = ModuleBRModule.extensionVersion;
    extensionFees.value = ModuleBRModule.extensionFees;
    redeemContract.value = ModuleBRModule.redeemContract;
    studioInstance.value = ModuleBRModule.studioInstance;
    redeemAssetMetadata.value = ModuleBRModule.redeemAssetMetadata;
    status.value = ModuleBRModule.status;
    contractsToApprove.value = ModuleBRModule.contractsToApprove;
  });

  return {
    extensionAddress,
    burnRedeemIndex,
    redeemContractAddress,
    extensionVersion,
    extensionFees,
    burn,
    redeemSpec,
    burnSpecs,
    extensionContract: extensionContract as Ref<IBRModuleState['extensionContract']>,
    redeemContract: redeemContract as Ref<IBRModuleState['redeemContract']>,
    studioInstance,
    redeemAssetMetadata,
    status,
    contractsToApprove,
  };
}
